import clsx from "clsx";
import styles from "./SpotlightForLens.module.css";
import gridStyles from "./ResponsiveGrid.module.css";
import { resize } from "@snapchat/web-core-ui";
export function SpotlightsForLensGrid(props) {
    const maxSpotlights = props.size === "large" ? 8 : 6;
    return (<div className={clsx(gridStyles.grid, { [gridStyles.gridLarge]: props.size === "large" })}>
      {props.spotlights.slice(0, maxSpotlights).map((spotlight) => (<SpotlightTile key={spotlight.storyPageUrl} spotlight={spotlight} lensName={props.lensName} size={props.size}/>))}
    </div>);
}
export function SpotlightTile(props) {
    const MAX_HEIGHT = 247;
    return (<a href={props.spotlight.storyPageUrl} className={clsx(styles.spotlightLink, {
            [styles.spotlightLinkLarge]: props.size === "large",
        })}>
      <img src={resize({
            imageUrl: props.spotlight.thumbnailUrl,
            width: 0,
            height: MAX_HEIGHT,
        })} className={styles.spotlightImage} 
    // eslint-disable-next-line formatjs/no-literal-string-in-jsx
    alt={`Preview for a Spotlight video that uses the ${props.lensName} Lens`} loading="lazy"/>
    </a>);
}
